import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductListingComponent } from './product-listing/product-listing.component';

const routes: Routes = [
  { path: 'productListing', component: ProductListingComponent},
  { path: 'product', component: ProductListComponent},
  {path: 'productListing', children: [
    {'path': '**', component: ProductListingComponent}
  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsListPageRoutingModule { }
